module.exports = __webpack_public_path__ + "img/edge_activites_tir.a69cffd1.svg";